import React, { useEffect, useRef, useState, useMemo } from "react";
import store from "@/stores/clip/player";
import {
  VideoMaterial,
  VideoGroup as VideoGroupProps,
} from "@/stores/clip/class/VideoTrack";
import { getGridPixel } from "@/utils/canvasUtil";
import trackStateStore from "@/stores/clip/trackState";
import { formatPlayerTime } from "@/utils/tool";
import { IconPlusCircle } from "@arco-design/web-react/icon";

interface VideoItemProps {
  trackItem: VideoGroupProps;
  itemIndex: number;
}

const VideoGroup: React.FC<VideoItemProps> = ({ trackItem, itemIndex }) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const [loading, setLoading] = useState(true);
  const [imgs, setImgs] = useState<string[]>([]);
  const [containerWidth, setContainerWidth] = useState(100);
  const nums = [
    "一",
    "二",
    "三",
    "四",
    "五",
    "六",
    "七",
    "八",
    "九",
    "十",
    "十一",
    "十二",
    "十三",
    "十四",
    "十五",
  ];

  // useEffect(() => {
  //   console.log(trackItem.materials);
  // }, []);

  // 格式化播放时间
  const playTime = useMemo(() => {
    return formatPlayerTime(store.playStartFrame);
  }, [store.playStartFrame]);

  // 格式化总时间
  const allTime = useMemo(() => {
    return formatPlayerTime(trackStateStore.getFrameCount());
  }, [trackStateStore.getFrameCount()]);

  useEffect(() => {
    const target = containerRef.current;
    if (!target) return;

    const resizeObserver = new ResizeObserver((entries) => {
      const { width } = entries[0].contentRect;
      setContainerWidth(width);
    });

    resizeObserver.observe(target);

    return () => {
      resizeObserver.unobserve(target);
    };
  }, []);

  return (
    <div
      className={`video-group`}
      style={{
        overflow: "hidden",
        height: "68px",
        userSelect: "none",
        background: "#103EAA",
        borderRadius: 6,
      }}
      ref={containerRef}
    >
      <div
        style={{
          position: "relative",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          overflow: "hidden",
          height: "100%",
          color: "#fff",
          fontSize: 12,
        }}
      >
        <span
          className="mr-4 shrink-0"
          style={{ position: "absolute", right: 10, top: 4 }}
        >
          {formatPlayerTime(trackItem.end - trackItem.start)}
        </span>
        <IconPlusCircle style={{ fontSize: 20 }} />
        <span
          className="mr-4 shrink-0"
          style={{
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
            padding: "4px",
          }}
        >
          {`${trackItem.name}`}
          {nums[itemIndex]}({trackItem.materials.length})
        </span>
      </div>

      {/* <div className="leading-3 pl-2 overflow-hidden h-3 bg-gray-700 relative"> */}
      {/* <img src={waveFileUrl} style={waveStyle} className="absolute left-0 right-0 top-0 bottom-0 h-full min-w-full" alt="" /> */}
      {/* </div> */}
      {/* {!!loading && (
        <div
          style={{
            position: "absolute",
            left: 0,
            right: 0,
            top: 0,
            bottom: 0,
            background: "rgba(255, 255, 255, 0.6)",
          }}
        >
          <div
            style={{
              position: "absolute",
              top: 18,
              left: 12,
              display: "flex",
              alignItems: "center",
              color: "#165dff",
              fontSize: 12,
            }}
          >
            <Spin style={{ marginRight: 5 }} /> 解析中..
          </div>
        </div>
      )} */}
    </div>
  );
};

export default VideoGroup;
